import { User } from "../models/User";
import { SIGN_IN } from "../resources/links";
import useUserAccount from "./userAccountHook";

function useAuth() {
    const { getAccount, getProfile } = useUserAccount();
    const user = new User(getProfile());
    const isSignInRoute = location.pathname === SIGN_IN;
    const redirectRoute = encodeURIComponent(location.pathname + location.search)

    const signInWithEmail = async () => {

        return;
    }

    const signInWithGoogle = async () => {

        return;
    }

    const signUserOut = async () => {

        return;
    }

    const isInsurerOnboarding = (): boolean => {
        // Insurer signup used to force-redirect into a bank-account + store setup wizard
        // (see InsurerOnboarding.tsx). Per product feedback, insurers now land directly on
        // the Overview Dashboard, which surfaces a Setup Checklist widget instead.
        // Returning false here neuters the gate at every call site (DashboardLayout, SignIn,
        // Router redirect) without needing to touch each one.
        return false;
        // return getAccount().isAuthenticated && user.isInsurer() && !getProfile().company?.setupCompleted;
    }

    const getPathToSignIn = () => {
        if (isSignInRoute) {
            return SIGN_IN;
        }
        return `${SIGN_IN}${redirectRoute ? `?redirect=${redirectRoute}` : ''}`;
    };

    return {
        signInWithEmail,
        signInWithGoogle,
        signUserOut,
        isInsurerOnboarding,
        getPathToSignIn
    }
}

export default useAuth;